/**
 * MOVit chytrý dotazník (ESHO-111) — engine + rendering.
 *
 * Vyhodnocení dle dokumentu "MOVit dotazník - popis vyhodnocovacího systému":
 *  1. tvrdý filtr (PRODUCTS[].no) — produkt s "Ne" u jakéhokoli aktivního filtru vypadne,
 *  2. skóre = shoda oblastí z otázky 4 (PRODUCTS[].s) + doplňkové body (PRODUCTS[].w)
 *     + bonusové body 16x (PRODUCTS[].b, jen při nenulovém skóre v oblasti otázky)
 *     + kombinace odpovědí (PRODUCTS[].c),
 *  3. sestavení výsledku: hlavní čtyřka (min. 1 / max. 2 z každé zobrazené oblasti,
 *     max. 1 z produktové řady, případně 1 "outsider" s ≥ 6 doplňkovými body)
 *     a pod ní seznam produktů pro každou zobrazenou oblast.
 * "Nevím, poradíte mi?" = skóre přes všechny oblasti, zobrazené oblasti určí hlasování
 * TOP 8 produktů. Data (otázky/produkty/váhy/parametry) jsou v smart-quiz-data.js —
 * tento soubor se při změně dat neupravuje.
 */
(function () {
  if (customElements.get('smart-quiz-app')) return;

  const CHK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
  const BACK_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  const HELP_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>';
  const DOCTOR_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l9 4v6c0 5-3.5 8-9 10-5.5-2-9-5-9-10V6z"/></svg>';
  const TAG_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0L2 12V2h10l8.6 8.6a2 2 0 010 2.8z"/><circle cx="7" cy="7" r="1.5"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }

  /* ---------- Engine (čisté funkce nad SmartQuizData) ---------- */
  const Engine = {
    isVisible(data, q, a) {
      if (q.showIf && !q.showIf(a)) return false;
      if (q.gateArea && !data.has(a, 'q4', q.gateArea)) return false;
      return true;
    },
    visibleQs(data, a) {
      return data.QUESTIONS.filter((q) => Engine.isVisible(data, q, a));
    },
    // Hodnoty `prop` (filter/bonus) u zvolených odpovědí — jen u otázek, které jsou
    // aktuálně viditelné (stará odpověď ze skryté větve se nepočítá).
    activeKeys(data, a, prop) {
      const out = new Set();
      Engine.visibleQs(data, a).forEach((q) =>
        q.options.forEach((o) => {
          if (o[prop] && data.has(a, q.id, o.value)) out.add(o[prop]);
        })
      );
      return out;
    },
    isAdvisor(data, a) {
      return data.has(a, 'q4', 'poradte');
    },
    selectedAreas(data, a) {
      if (Engine.isAdvisor(data, a)) return data.AREAS.map((ar) => ar.key);
      const keys = new Set(data.AREAS.map((ar) => ar.key));
      return (a.q4 || []).filter((v) => keys.has(v));
    },
    // `excluded` = ID produktů, které nejde zobrazit (vyprodané/skryté ve vyhledávání).
    score(data, a, excluded) {
      const filters = Engine.activeKeys(data, a, 'filter');
      const points = Engine.activeKeys(data, a, 'bonus');
      const gate = {};
      data.QUESTIONS.forEach((q) => {
        if (q.gateArea) q.options.forEach((o) => o.bonus && (gate[o.bonus] = q.gateArea));
      });
      const areas = Engine.selectedAreas(data, a);
      const out = [];
      data.PRODUCTS.forEach((p, order) => {
        if ((p.no || []).some((f) => filters.has(f))) return;
        if (excluded && excluded.has(String(p.id))) return;
        const cat = areas.reduce((sum, ar) => sum + (p.s[ar] || 0), 0);
        let supp = 0;
        for (const [k, v] of Object.entries(p.w || {})) if (points.has(k)) supp += v;
        const bonus = (p.b || []).filter((k) => {
          if (!points.has(k)) return false;
          const g = gate[k];
          return g === 'poradte' ? cat > 0 : (p.s[g] || 0) > 0;
        }).length;
        const combo = (p.c || []).filter((k) => data.COMBOS[k] && data.COMBOS[k](a)).length;
        out.push({ p, order, cat, supp, total: cat + supp + bonus + combo });
      });
      return out.sort((x, y) => y.total - x.total || x.order - y.order);
    },
    // Oblasti zobrazené ve výsledku (kap. 6.1 a 6.4).
    shownAreas(data, a, scored) {
      if (!Engine.isAdvisor(data, a)) return Engine.selectedAreas(data, a);
      const R = data.RESULTS;
      const votes = new Map();
      scored
        .filter((r) => r.cat > 0)
        .slice(0, R.advisorTopN)
        .forEach((r) => {
          let best = null;
          data.AREAS.forEach((ar) => {
            const v = r.p.s[ar.key] || 0;
            if (v > 0 && (best === null || v > (r.p.s[best] || 0))) best = ar.key;
          });
          if (best) votes.set(best, (votes.get(best) || 0) + 1);
        });
      const ranked = data.AREAS.map((ar) => ar.key)
        .filter((k) => votes.has(k))
        .sort((x, y) => votes.get(y) - votes.get(x));
      if (ranked.length <= R.advisorAreas) return ranked;
      // Remíza na hranici: všechny se stejným počtem hlasů jako poslední "standardní"
      // oblast. Vejdou-li se do maxAreas, zobrazí se všechny, jinak se dobere náhodně.
      const edge = votes.get(ranked[R.advisorAreas - 1]);
      const above = ranked.filter((k) => votes.get(k) > edge);
      const tied = ranked.filter((k) => votes.get(k) === edge);
      if (above.length + tied.length <= R.maxAreas) return above.concat(tied);
      const pool = tied.slice();
      const picked = [];
      while (above.length + picked.length < R.maxAreas && pool.length) {
        picked.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]);
      }
      return above.concat(tied.filter((k) => picked.includes(k)));
    },
    // Hlavní čtyřka (kap. 6.2).
    pickMain(data, scored, areas) {
      const R = data.RESULTS;
      const inAreas = (r) => areas.some((ar) => (r.p.s[ar] || 0) > 0);
      const lineOf = (r) => r.p.line || '#' + r.p.id;
      const main = [];
      const count = {};
      const taken = (r) => main.some((m) => m.r === r);
      const lineUsed = (r, except) => main.some((m) => m !== except && lineOf(m.r) === lineOf(r));
      const take = (r, area, guaranteed) => {
        main.push({ r, area, guaranteed });
        count[area] = (count[area] || 0) + 1;
      };
      const eligible = scored.filter(inAreas);

      // 1) z každé zobrazené oblasti garantovaně nejlepší produkt
      areas.forEach((ar) => {
        if (main.length >= R.mainCount) return;
        const r = eligible.find((x) => !taken(x) && !lineUsed(x) && (x.p.s[ar] || 0) > 0);
        if (r) take(r, ar, true);
      });
      // 2) zbylé sloty podle skóre, max. maxPerArea na oblast (limit slouží k zastoupení
      //    více oblastí — u jediné oblasti by jinak zůstala čtyřka poloprázdná)
      const cap = areas.length > 1 ? R.maxPerArea : R.mainCount;
      for (const r of eligible) {
        if (main.length >= R.mainCount) break;
        if (taken(r) || lineUsed(r)) continue;
        let best = null;
        areas.forEach((ar) => {
          const v = r.p.s[ar] || 0;
          if (v > 0 && (count[ar] || 0) < cap && (best === null || v > (r.p.s[best] || 0))) best = ar;
        });
        if (best) take(r, best, false);
      }
      // 3) produkt mimo zobrazené oblasti s dostatkem doplňkových bodů
      const outsiders = scored
        .filter((r) => !inAreas(r) && r.supp >= R.outsiderMinPoints)
        .sort((x, y) => y.supp - x.supp || y.total - x.total);
      for (const o of outsiders) {
        if (main.length < R.mainCount) {
          if (lineUsed(o)) continue;
          main.push({ r: o, area: null, guaranteed: false });
          break;
        }
        let target = null;
        if (areas.length >= 3) {
          // 2+1+1: smí nahradit jen slot navíc, garantované produkty se neruší
          target = main.filter((m) => !m.guaranteed).pop() || null;
        } else {
          main.forEach((m) => {
            if (!target || m.r.total <= target.r.total) target = m;
          });
        }
        if (!target) break;
        if (lineUsed(o, target)) continue;
        main[main.indexOf(target)] = { r: o, area: null, guaranteed: false };
        break;
      }
      return main.map((m) => m.r).sort((x, y) => y.total - x.total || x.order - y.order);
    },
    // Seznam pod každou zobrazenou oblastí (kap. 6.3).
    areaLists(data, scored, areas, main) {
      const R = data.RESULTS;
      const mainIds = new Set(main.map((r) => r.p.id));
      return areas.map((ar) => ({
        area: ar,
        items: scored
          .filter((r) => (r.p.s[ar] || 0) >= R.areaListMinScore)
          .filter((r) => !(R.areaListExcludeMain && mainIds.has(r.p.id)))
          .slice(0, R.areaListCount),
      }));
    },
    recommend(data, a, excluded) {
      const scored = Engine.score(data, a, excluded);
      const areas = Engine.shownAreas(data, a, scored);
      const main = Engine.pickMain(data, scored, areas);
      return { areas, main, lists: Engine.areaLists(data, scored, areas, main) };
    },
  };
  window.SmartQuizEngine = Engine;

  // Průběh i výsledek dotazníku přežije refresh/návrat — uloženo v localStorage na 30 dní
  // od poslední změny. Výsledek se ukládá jen jako ID produktů (karty se načtou čerstvé),
  // aby zůstal stejný jako slevový kód vystavený na tyto produkty.
  const STORAGE_KEY = 'movit-smart-quiz';
  const STORAGE_TTL = 30 * 24 * 60 * 60 * 1000;
  const Store = {
    load() {
      try {
        const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        if (saved && saved.v === 1 && Date.now() - saved.savedAt < STORAGE_TTL) return saved;
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      return null;
    },
    save(payload) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: 1, savedAt: Date.now(), ...payload }));
      } catch (e) {}
    },
    clear() {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    },
  };

  class SmartQuizApp extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const data = window.SmartQuizData;
      if (!data) {
        console.error('[smart-quiz] Chybí SmartQuizData — zkontrolujte, že je smart-quiz-data.js načtený před smart-quiz.js.');
        return;
      }
      this.data = data;

      this.searchUrl = this.dataset.searchUrl;
      this.sectionId = this.dataset.sectionId;
      this.logoUrl = this.dataset.logoUrl;
      this.shopName = this.dataset.shopName || 'MOVit';
      this.leadApiUrl = (this.dataset.leadApiUrl || '').replace(/\/+$/, '');
      this.discountEnabled = this.dataset.discount === 'true';
      this.areaLinks = {};
      const linksEl = this.querySelector('[data-sq-area-links]');
      if (linksEl) {
        try {
          this.areaLinks = JSON.parse(linksEl.textContent) || {};
        } catch (e) {
          console.error('[smart-quiz] Neplatné odkazy na kolekce oblastí', e);
        }
      }

      this.newsletterForm = this.querySelector('#SmartQuizNewsletterForm');

      this.state = { view: 'intro', answers: {}, currentId: data.QUESTIONS[0].id };
      this.restore();

      this.buildSkeleton();
      this.render();
    }

    buildSkeleton() {
      const skeleton = document.createElement('div');
      skeleton.className = 'sq-shell';
      skeleton.innerHTML = `
        <header class="sq-header">
          <div class="sq-hbar">
            <button type="button" class="sq-back sq-is-hidden" aria-label="Zpět">${BACK_ICON}</button>
            ${this.logoUrl ? `<img class="sq-logo" src="${esc(this.logoUrl)}" alt="${esc(this.shopName)}">` : `<span class="sq-logo-text">${esc(this.shopName)}</span>`}
          </div>
        </header>
        <div class="sq-progress-wrap sq-is-hidden"><div class="sq-progress"><i class="sq-progress-bar" style="width:6%"></i></div></div>
        <div class="sq-steplabel sq-is-hidden"></div>
        <main class="sq-main"></main>
      `;
      this.prepend(skeleton);
      this.shell = skeleton;
      this.header = skeleton.querySelector('.sq-header');
      this.backBtn = skeleton.querySelector('.sq-back');
      this.progressWrap = skeleton.querySelector('.sq-progress-wrap');
      this.progressBar = skeleton.querySelector('.sq-progress-bar');
      this.stepLabel = skeleton.querySelector('.sq-steplabel');
      this.main = skeleton.querySelector('.sq-main');

      this.backBtn.addEventListener('click', () => this.goBack());
    }

    visibleQs(a) {
      return Engine.visibleQs(this.data, a);
    }

    /* ---------- Uložený průběh ---------- */
    restore() {
      const saved = Store.load();
      if (!saved || !saved.state) return;
      const { view, answers, currentId } = saved.state;
      this.state = { view, answers: answers || {}, currentId: currentId || this.state.currentId };
      // Refresh během výpočtu: e-mail se neukládá, zákazník ho zadá znovu.
      if (view === 'calc') this.state.view = 'email';
      if (view === 'results') {
        this.resultData = this.unpackResult(saved.result);
        if (!this.resultData) this.state.view = 'email';
      }
      if (!['intro', 'quiz', 'email', 'results'].includes(this.state.view)) this.state.view = 'intro';
    }

    persist() {
      const state = { view: this.state.view, answers: this.state.answers, currentId: this.state.currentId };
      const result = this.state.view === 'results' && this.resultData ? this.packResult(this.resultData) : null;
      Store.save(result ? { state, result } : { state });
    }

    packResult({ rec, discount }) {
      const ids = (items) => items.map((r) => r.p.id);
      return {
        areas: rec.areas,
        main: ids(rec.main),
        lists: rec.lists.map((l) => ({ area: l.area, ids: ids(l.items) })),
        discount: discount || null,
      };
    }

    unpackResult(saved) {
      if (!saved || !Array.isArray(saved.main)) return null;
      const byId = new Map(this.data.PRODUCTS.map((p) => [String(p.id), p]));
      const items = (ids) => (ids || []).map((id) => byId.get(String(id))).filter(Boolean).map((p) => ({ p }));
      let discount = saved.discount || null;
      // Prošlý slevový kód už nenabízíme.
      if (discount && discount.expiresAt && Date.parse(discount.expiresAt) < Date.now()) discount = null;
      return {
        rec: {
          areas: saved.areas || [],
          main: items(saved.main),
          lists: (saved.lists || []).map((l) => ({ area: l.area, items: items(l.ids) })),
        },
        cards: null,
        discount,
      };
    }

    /* ---------- Render dispatch ---------- */
    render() {
      this.persist();
      const showChrome = this.state.view === 'quiz';
      const isResults = this.state.view === 'results';
      this.classList.toggle('sq-light', isResults);
      this.classList.toggle('sq-fullscreen', !isResults);
      document.documentElement.classList.toggle('sq-lock-scroll', !isResults);
      // Na výsledcích už je plná hlavička e-shopu — vlastní lišta s logem by byla navíc.
      this.header.classList.toggle('sq-is-hidden', isResults);
      this.progressWrap.classList.toggle('sq-is-hidden', !showChrome);
      this.stepLabel.classList.toggle('sq-is-hidden', !showChrome);
      this.backBtn.classList.toggle('sq-is-hidden', ['intro', 'calc', 'results'].includes(this.state.view));

      if (this.state.view === 'intro') return this.renderIntro();
      if (this.state.view === 'quiz') return this.renderQuestion();
      if (this.state.view === 'email') return this.renderEmail();
      if (this.state.view === 'calc') return this.renderCalc();
      if (this.state.view === 'results') return this.renderResults();
    }

    renderIntro() {
      const R = this.data.RESULTS;
      // Počet otázek, které vidí každý (bez podotázek závislých na odpovědích).
      const baseCount = this.visibleQs({}).length;
      this.main.innerHTML = `
        <div class="sq-stage"><div class="sq-center">
          <div class="sq-badge-ico"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 5.4L20 8l-4 4 1 6-5-2.8L7 18l1-6-4-4 5.6-.6z"/></svg></div>
          <h1 class="sq-h1-xl">Poradíme vám, co brát</h1>
          <p class="sq-lead">Pár otázek o vašem zdraví, spánku a životním stylu. Podle odpovědí vám sestavíme <b>${R.mainCount} doplňky na míru</b>.</p>
          <div class="sq-stats">
            <div class="sq-stat"><b>~2 min</b><span>zabere to</span></div>
            <div class="sq-stat-div no-empty"></div>
            <div class="sq-stat"><b>~${baseCount} otázek</b><span>jen relevantní</span></div>
          </div>
        </div>
        <div class="sq-footer-cta"><button type="button" class="sq-btn sq-btn-primary" data-action="start">Spustit dotazník →</button></div></div>
      `;
      this.main.querySelector('[data-action="start"]').addEventListener('click', () => this.startQuiz());
    }

    currentQ() {
      const v = this.visibleQs(this.state.answers);
      return v.find((q) => q.id === this.state.currentId) || v[0];
    }

    renderQuestion() {
      const v = this.visibleQs(this.state.answers);
      const q = this.currentQ();
      const idx = v.findIndex((x) => x.id === q.id);
      const pct = Math.round(Math.sqrt((idx + 1) / v.length) * 100);
      this.progressBar.style.width = pct + '%';
      this.stepLabel.textContent = q.section + ' · ' + (idx + 1) + '/' + v.length;
      const sel = this.state.answers[q.id] || [];
      const atMax = q.max && sel.filter((val) => !this.isExclusive(q, val)).length >= q.max;
      const opts = q.options
        .map((o) => {
          const on = sel.includes(o.value);
          const off = atMax && !on && !o.exclusive;
          const hint = o.hint ? `<small class="sq-opt-hint">${esc(o.hint)}</small>` : '';
          return `<button type="button" class="sq-opt${on ? ' is-selected' : ''}${off ? ' is-disabled' : ''}" data-value="${esc(o.value)}"${off ? ' disabled' : ''}><span class="sq-box">${CHK}</span><span class="sq-opt-text"><span>${esc(o.label)}</span>${hint}</span></button>`;
        })
        .join('');
      const help = q.help
        ? `<div class="sq-help">${HELP_ICON}<span>${esc(q.help)}</span></div>`
        : '<div class="sq-help-spacer no-empty"></div>';
      const notes = q.options.filter((o) => o.note && sel.includes(o.value));
      const noteHtml = notes.map((o) => `<div class="sq-qnote">${DOCTOR_ICON}<span>${esc(o.note)}</span></div>`).join('');
      const canProceed = !q.required || sel.length > 0;
      // Jednovýběrová otázka se sama posune dál; s upozorněním musí zákazník potvrdit, aby ho viděl.
      const cta =
        q.type === 'multi' || notes.length
          ? `<div class="sq-footer-cta"><button type="button" class="sq-btn sq-btn-primary" data-action="advance" ${canProceed ? '' : 'disabled'}>Pokračovat →</button></div>`
          : '';
      this.main.innerHTML = `<div class="sq-stage"><h1 class="sq-q-title">${esc(q.title)}</h1>${help}<div class="sq-options">${opts}</div>${noteHtml}${cta}</div>`;

      this.main.querySelectorAll('.sq-opt').forEach((btn) => {
        btn.addEventListener('click', () => this.pick(q, btn.dataset.value));
      });
      const advanceBtn = this.main.querySelector('[data-action="advance"]');
      if (advanceBtn) advanceBtn.addEventListener('click', () => this.advance());
    }

    isExclusive(q, val) {
      const o = q.options.find((x) => x.value === val);
      return !!(o && (o.exclusive || o.skip));
    }

    pick(q, val) {
      if (q.type === 'single') {
        this.state.answers[q.id] = [val];
        this.persist();
        const o = q.options.find((x) => x.value === val);
        if (o && o.note) {
          this.renderQuestion();
          return;
        }
        window.setTimeout(() => this.advance(), 200);
        return;
      }
      const cur = this.state.answers[q.id] || [];
      let next;
      if (this.isExclusive(q, val)) next = cur.includes(val) ? [] : [val];
      else if (cur.includes(val)) next = cur.filter((v) => v !== val);
      else {
        next = cur.filter((v) => !this.isExclusive(q, v));
        if (q.max && next.length >= q.max) return;
        next = next.concat(val);
      }
      this.state.answers[q.id] = next;
      this.persist();
      this.renderQuestion();
    }

    advance() {
      const v = this.visibleQs(this.state.answers);
      const idx = v.findIndex((q) => q.id === this.state.currentId);
      const next = v[idx + 1];
      if (next) {
        this.state.currentId = next.id;
      } else {
        this.state.view = 'email';
      }
      window.scrollTo(0, 0);
      this.render();
    }

    goBack() {
      if (this.state.view === 'email') {
        this.state.view = 'quiz';
        this.render();
        return;
      }
      const v = this.visibleQs(this.state.answers);
      const idx = v.findIndex((q) => q.id === this.state.currentId);
      if (idx > 0) {
        this.state.currentId = v[idx - 1].id;
      } else {
        this.state.view = 'intro';
      }
      this.render();
    }

    startQuiz() {
      this.state.view = 'quiz';
      this.state.currentId = this.visibleQs(this.state.answers)[0].id;
      window.scrollTo(0, 0);
      this.render();
    }

    /* ---------- E-mail gate ---------- */
    renderEmail() {
      this.main.innerHTML = `
        <div class="sq-stage"><div class="sq-center sq-center-top">
          <div class="sq-badge-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M4 7l8 6 8-6"/></svg></div>
          <h1 class="sq-h1-md">Ještě poslední krok</h1>
          <p class="sq-lead">Zadejte svůj e-mail a hned vám ukážeme <b>doplňky na míru</b>.</p>
          <input class="sq-field" type="email" data-el="email" placeholder="vas@email.cz" autocomplete="email">
          <label class="sq-consent">
            <input type="checkbox" data-el="opt-out">
            <span>Nepřeji si dostávat informace o novinkách ani akčních nabídkách</span>
          </label>
        </div>
        <div class="sq-footer-cta"><button type="button" class="sq-btn sq-btn-primary" data-action="submit-email" disabled>Zobrazit doporučení →</button></div></div>
      `;
      const emailInput = this.main.querySelector('[data-el="email"]');
      const submitBtn = this.main.querySelector('[data-action="submit-email"]');
      emailInput.addEventListener('input', () => {
        submitBtn.disabled = !this.validEmail(emailInput.value.trim());
      });
      submitBtn.addEventListener('click', () => this.submitEmail());
    }

    validEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    submitEmail() {
      const email = this.main.querySelector('[data-el="email"]').value.trim();
      // Zaškrtnutí = nesouhlas (opt-out), stejně jako v košíku.
      const consent = !this.main.querySelector('[data-el="opt-out"]').checked;
      this.leadEmail = email;
      this.leadConsent = consent;
      this.state.view = 'calc';
      this.render();
      this.prepareResults(email, consent);
    }

    // Během animace výpočtu spočítá doporučení, načte karty a založí lead — se
    // zapnutou slevou backend vrátí i unikátní slevový kód na doporučené produkty.
    async prepareResults(email, consent) {
      const minDelay = new Promise((resolve) => window.setTimeout(resolve, 1800));
      const result = await this.loadRecommendation();
      result.discount = await this.captureLead(email, consent, this.discountEnabled ? this.leadProducts(result) : null);
      await minDelay;
      if (!this.isConnected || this.state.view !== 'calc') return;
      this.resultData = result;
      this.state.view = 'results';
      window.scrollTo(0, 0);
      this.render();
    }

    // Produkty, na které se vztahuje slevový kód: hlavní čtyřka + seznamy oblastí,
    // jen ty, jejichž kartu se podařilo načíst (tj. opravdu se zobrazí).
    leadProducts({ rec, cards }) {
      if (!cards) return null;
      const ids = (items) => items.map((r) => String(r.p.id)).filter((id) => cards[id]);
      const main = ids(rec.main);
      const areas = rec.lists
        .map((l) => ({ label: (this.areaMeta(l.area) || {}).label || l.area, ids: ids(l.items) }))
        .filter((a) => a.ids.length);
      return { main, areas };
    }

    // Založení zákazníka (s/bez marketingového souhlasu) přes backend
    // movit-b2b-registration /api/smart-quiz/lead. S produkty backend vytvoří
    // i slevový kód a vrátí ho ({ code, expiresAt, expiresLabel }), jinak null.
    // Bez nastavené URL se použije jen nativní Shopify formulář, který umí
    // zákazníka založit pouze jako přihlášeného k newsletteru — proto jen při
    // souhlasu. Nekritické pro zobrazení výsledků, proto s časovým limitem.
    async captureLead(email, consent, products) {
      if (this.leadApiUrl) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 10000);
        try {
          const res = await fetch(`${this.leadApiUrl}/api/smart-quiz/lead`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(products ? { email, consent, products } : { email, consent }),
            signal: controller.signal,
          });
          if (res.ok) {
            const body = await res.json().catch(() => ({}));
            return body.discount && body.discount.code ? body.discount : null;
          }
          console.warn('[smart-quiz] Lead API vrátilo chybu', res.status);
        } catch (e) {
          console.warn('[smart-quiz] Lead API nedostupné', e);
        } finally {
          window.clearTimeout(timer);
        }
      }
      if (consent) this.subscribeToNewsletter(email);
      return null;
    }

    // Uloží kód do košíku (Shopify ho drží v cookie a uplatní v košíku/pokladně),
    // zákazník ho tak nemusí opisovat.
    applyDiscount(code) {
      fetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart.js')}`, {
        credentials: 'same-origin',
      }).catch((e) => console.warn('[smart-quiz] Uplatnění slevového kódu se nepodařilo', e));
    }

    async subscribeToNewsletter(email) {
      if (!this.newsletterForm) return;
      const emailField = this.newsletterForm.querySelector('input[name="contact[email]"]');
      if (emailField) emailField.value = email;
      const formData = new FormData(this.newsletterForm);
      try {
        const res = await fetch(this.newsletterForm.action, { method: 'POST', body: formData, credentials: 'same-origin' });
        if (!res.ok || /\/challenge/.test(res.url)) {
          console.warn('[smart-quiz] Přihlášení k newsletteru se nepodařilo (chyba nebo captcha)', res.status, res.url);
        }
      } catch (e) {
        console.warn('[smart-quiz] Přihlášení k newsletteru se nepodařilo', e);
      }
    }

    /* ---------- Calc ---------- */
    renderCalc() {
      this.main.innerHTML = `
        <div class="sq-stage"><div class="sq-center sq-center-mid">
          <div class="sq-spinner"></div>
          <h2 class="sq-calc-title">Sestavuji vaše doporučení…</h2>
        </div></div>
      `;
    }

    /* ---------- Results ---------- */
    areaMeta(key) {
      return this.data.AREAS.find((a) => a.key === key);
    }

    // Doporučení + produktové karty. Produkt, jehož kartu vyhledávání nevrátí
    // (vyprodaný, skrytý z vyhledávání), se vyřadí a doporučení se přepočítá, aby
    // jeho místo zaujal další v pořadí místo prázdného slotu.
    async loadRecommendation() {
      const excluded = new Set();
      const cards = {};
      let rec;
      for (let round = 0; round < 5; round++) {
        rec = Engine.recommend(this.data, this.state.answers, excluded);
        const ids = [...new Set(rec.main.concat(...rec.lists.map((l) => l.items)).map((r) => String(r.p.id)))].filter(
          (id) => !(id in cards)
        );
        if (!ids.length) break;
        const fetched = await this.fetchProductCards(ids);
        if (!fetched) return { rec, cards: null };
        ids.forEach((id) => {
          cards[id] = fetched[id] || '';
          if (!fetched[id]) excluded.add(id);
        });
      }
      return { rec, cards };
    }

    async renderResults() {
      this.main.innerHTML = `<div class="sq-grid"><div class="sq-loading">Načítám doporučené produkty…</div></div>`;
      if (!this.resultData) {
        this.resultData = await this.loadRecommendation();
        this.persist();
      } else if (!this.resultData.cards) {
        // Obnovený výsledek — karty načíst čerstvé (aktuální cena/sklad); nedostupné se vynechají.
        const { rec } = this.resultData;
        const ids = [...new Set(rec.main.concat(...rec.lists.map((l) => l.items)).map((r) => String(r.p.id)))];
        this.resultData.cards = await this.fetchProductCards(ids);
      }
      if (!this.isConnected || this.state.view !== 'results') return;
      const { rec, cards, discount: code } = this.resultData;
      const chips = rec.areas
        .map((k) => {
          const m = this.areaMeta(k);
          return m ? `<span class="sq-chip">${m.emoji} ${esc(m.short)}</span>` : '';
        })
        .join('');
      const warning = this.data.unverified(this.state.answers)
        ? `<div class="sq-note">${DOCTOR_ICON}<span>Neuvedli jste věk nebo pohlaví, proto jsme <b>nemohli ověřit vhodnost všech produktů</b> (např. pro děti, těhotné či kojící ženy). Před nákupem si prosím přečtěte upozornění u každého produktu.</span></div>`
        : '';
      // Sleva platí jen na hlavní doporučení, a to na ta, která se opravdu zobrazí.
      const mainCount = rec.main.filter((r) => cards && cards[String(r.p.id)]).length;
      const tiers = this.data.DISCOUNT_TIERS.filter((t) => t.count <= mainCount);
      const products = (n) => `${n} ${n === 1 ? 'produkt' : n < 5 ? 'produkty' : 'produktů'}`;
      const discount =
        this.discountEnabled && code && tiers.length
          ? `<div class="sq-promo sq-promo-discount">
              <h2 class="sq-promo-title">${TAG_ICON}<span>Získejte slevu až ${tiers[tiers.length - 1].percent}&nbsp;% na doporučené produkty</span></h2>
              <p class="sq-promo-text">Doporučili jsme vám ${products(mainCount)}, čím více jich zakoupíte, tím větší slevu dostanete.</p>
              <ul class="sq-promo-tiers">${tiers
                .map((t) => `<li><span>${products(t.count)}</span><b>sleva ${t.percent}&nbsp;%</b></li>`)
                .join('')}</ul>
              <div class="sq-promo-code"><span>Váš slevový kód platí do ${esc(code.expiresLabel)}:</span>
                <span class="sq-promo-codebox"><b data-el="discount-code">${esc(code.code)}</b>
                <button type="button" class="sq-promo-copy" data-action="copy-code">Kopírovat</button></span></div>
              <p class="sq-promo-note">Sleva se vztahuje na ${products(mainCount)} v sekci Doporučujeme právě vám. Kód už máte vložený v košíku a pošleme vám ho i e-mailem.</p>
            </div>`
          : '';
      const lists = rec.lists
        .filter((l) => l.items.length)
        .map((l) => {
          const m = this.areaMeta(l.area);
          const url = this.areaLinks[l.area];
          return `
            <section class="sq-area">
              <h2 class="sq-area-title">${m ? `${m.emoji} ${esc(m.label)}` : ''}</h2>
              <div class="sq-grid" data-el="area-grid" data-ids="${l.items.map((r) => r.p.id).join(',')}"></div>
              ${url ? `<div class="sq-area-more"><a class="btn btn--secondary" href="${esc(url)}">Zobrazit vše: ${esc(m ? m.label : '')}</a></div>` : ''}
            </section>`;
        })
        .join('');

      this.main.innerHTML = `
        <div class="sq-res-head">
          <h1 class="sq-h1-md">Sestavili jsme vám doplňky na míru</h1>
          <div class="sq-chips">${chips}</div>
        </div>
        ${warning}
        ${discount}
        <section class="sq-area"><h2 class="sq-area-title">Doporučujeme právě vám</h2></section>
        <div class="sq-grid" data-el="main-grid" data-ids="${rec.main.map((r) => r.p.id).join(',')}"></div>
        ${lists}
        <p class="sq-disclaimer">Toto není lékařská rada. Doporučení vychází z vašich odpovědí a slouží jako inspirace. Pokud užíváte léky, jste těhotná nebo kojíte, poraďte se s lékařem.</p>
        <div class="sq-restart-wrap"><button type="button" class="sq-btn sq-btn-ghost" data-action="restart">Projít dotazník znovu</button></div>
      `;
      this.main.querySelector('[data-action="restart"]').addEventListener('click', () => this.restart());
      const copyBtn = this.main.querySelector('[data-action="copy-code"]');
      if (copyBtn) {
        this.applyDiscount(code.code);
        copyBtn.addEventListener('click', () => {
          const done = () => {
            copyBtn.textContent = 'Zkopírováno';
          };
          if (navigator.clipboard) navigator.clipboard.writeText(code.code).then(done, () => {});
        });
      }

      this.main.querySelectorAll('[data-ids]').forEach((grid) => {
        const html = grid.dataset.ids
          .split(',')
          .filter((id) => cards && cards[id])
          .map((id) => `<div class="f-column card">${cards[id]}</div>`)
          .join('');
        if (grid.dataset.el === 'main-grid') {
          grid.innerHTML = html || `<p class="sq-loading">Doporučení se nepodařilo načíst. Zkuste to prosím znovu.</p>`;
        } else if (html) {
          grid.innerHTML = html;
        } else {
          grid.closest('.sq-area').remove();
        }
      });
    }

    // Karty přes Section Rendering API (search `id:X OR id:Y`), vrací { id: html },
    // při chybě sítě null. Vyhledávání vrací max. 10 výsledků, proto po dávkách.
    async fetchProductCards(ids) {
      if (!this.searchUrl || !ids.length) return {};
      const SEARCH_LIMIT = 10;
      const chunks = [];
      for (let i = 0; i < ids.length; i += SEARCH_LIMIT) chunks.push(ids.slice(i, i + SEARCH_LIMIT));
      try {
        const out = {};
        await Promise.all(
          chunks.map(async (chunk) => {
            const q = chunk.map((id) => 'id:' + id).join(' OR ');
            const url = `${this.searchUrl}?section_id=${encodeURIComponent(this.sectionId)}&type=product&q=${encodeURIComponent(q)}`;
            const res = await fetch(url);
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            doc.querySelectorAll('.sq-results-source [data-sq-product-id]').forEach((el) => {
              out[el.dataset.sqProductId] = el.innerHTML.trim();
            });
          })
        );
        return out;
      } catch (e) {
        console.error('[smart-quiz] Nepodařilo se načíst produktové karty', e);
        return null;
      }
    }

    restart() {
      this.state = { view: 'intro', answers: {}, currentId: this.data.QUESTIONS[0].id };
      this.resultData = null;
      Store.clear();
      window.scrollTo(0, 0);
      this.render();
    }
  }

  customElements.define('smart-quiz-app', SmartQuizApp);
})();
